export const FIREBASE_API_KEY = process.env.REACT_APP_API_KEY;
export const GOOGLE_FOLDER =
  process.env.GOOGLE_FOLDER ||
  "https://drive.google.com/drive/u/0/folders/1tkTVZ5snIbjTXbUL0FgCnBrD0fKWXUTj";
